module.exports = __webpack_public_path__ + "static/media/fullstack.ef39e76f.jpeg";